import { useContext, useEffect, useState } from "react";
import CampaignContext from "../../../contexts/CampaignContext";
import UserContext from "../../../contexts/UserContext";
import restService from "../../../restService";
import Leading from "./Leading";
import { addDays } from "date-fns";

const summary = () => {
  const [summary, setSummary] = useState({
    totalEntries: 0,
    totalValid: 0,
    totalInvalid: 0,
    totalWins: 0,
    totalIgnore: 0,
  });

  const [createdFrom, setCreatedFrom] = useState("");
  const [createdTo, setCreatedTo] = useState("");

  const [campaign] = useContext(CampaignContext);
  const [user] = useContext(UserContext);

  const [state, setState] = useState([
    {
      startDate: addDays(new Date(), -7).setHours(0, 0, 0, 0),
      endDate: new Date().setHours(23, 59, 59, 0),
      key: "selection",
    },
  ]);

  useEffect(() => {
    fetchSummary();
  }, [state]);

  // useEffect(() => {
  //   console.log(new Date(state[0].endDate).toISOString());
  // }, [state]);

  const fetchSummary = async () => {
    try {
      const {
        data: { data },
      } = await restService.Reports.DailyEntries(
        campaign?.id,
        new Date(state[0].startDate).toISOString(),
        new Date(state[0].endDate).toISOString()
      );

      const totalEntries = data.reduce((acc, curr) => {
        return acc + curr.total;
      }, 0);
      const totalValid = data.reduce((acc, curr) => {
        return acc + curr.valid;
      }, 0);
      const totalInvalid = data.reduce((acc, curr) => {
        return acc + curr.invalid;
      }, 0);
      const totalWins = data.reduce((acc, curr) => {
        return acc + curr.wins;
      }, 0);
      const totalIgnore = data.reduce((acc, curr) => {
        return acc + curr.ignored;
      }, 0);

      setSummary({
        totalEntries,
        totalValid,
        totalInvalid,
        totalWins,
        totalIgnore,
      });

      // console.log(totalEntries);
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div>
      <Leading
        createdFrom={createdFrom}
        createdTo={createdTo}
        summary={summary}
        setSummary={setSummary}
        setCreatedFrom={setCreatedFrom}
        setCreatedTo={setCreatedTo}
        setState={setState}
        state={state}
      />
      <div className="my-5">
        <div className="md:grid md:grid-cols-5 gap-5">
          <div className="rounded-md shadow-sm my-4 md:my-0 border border-orange-100 bg-white p-4 bg-gradient-to-r from-white to-orange-50">
            <div className="flex items-center">
              <div>
                <img
                  src="https://i.ibb.co/MRvTpXw/Group-2.png"
                  alt=""
                  width="42"
                  height="42"
                />
              </div>
              <div className="px-4">
                <p className="text-[#848484] m-0 p-0 md:text-sm text-xs whitespace-nowrap">
                  Total Entries
                </p>
                <p className="text-xl">{summary.totalEntries}</p>
              </div>
            </div>
          </div>

          <div className="rounded-md shadow-sm my-4 md:my-0 bg-white border border-green-100 p-4  bg-gradient-to-r from-white to-green-50">
            <div className="flex items-center">
              <div>
                <img
                  width="42"
                  height="42"
                  src="https://i.ibb.co/cxDMJNB/Group-2.png"
                  alt="total-valid-entries"
                />
              </div>
              <div className="px-4 overflow-hidden">
                <p className="text-[#848484] m-0 p-0 md:text-sm text-xs truncate whitespace-nowrap">
                  Total Valid Entries
                </p>
                <p className="text-xl">{summary.totalValid}</p>
              </div>
            </div>
          </div>

          <div className="rounded-md border my-4 md:my-0 border-red-100 bg-white shadow-sm p-4 bg-gradient-to-r from-white to-red-50">
            <div className="flex items-center">
              <div>
                <img
                  width="42"
                  height="42"
                  src="https://i.ibb.co/d7j1K0S/Group-2.png"
                  alt="total-valid-entries"
                />
              </div>
              <div className="px-4 overflow-hidden">
                <p className="text-[#848484] m-0 p-0 md:text-sm text-xs  truncate">
                  Total Invalid Entries
                </p>
                <p className="text-xl">{summary.totalInvalid}</p>
              </div>
            </div>
          </div>

          <div className="rounded-md border my-4 md:my-0 border-blue-100 bg-white shadow-sm p-4 bg-gradient-to-r from-white to-blue-50">
            <div className="flex items-center">
              <div>
                <img
                  width="42"
                  height="42"
                  src="https://i.ibb.co/2MMc6fF/Group-2.png"
                  alt="total-valid-entries"
                />
              </div>
              <div className="px-4 overflow-hidden">
                <p className="text-[#848484] m-0 p-0 md:text-sm text-xs truncate whitespace-nowrap">
                  Total Wins
                </p>
                <p className="text-xl">{summary.totalWins}</p>
              </div>
            </div>
          </div>

          <div className="rounded-md border my-4 md:my-0 bg-white shadow-md p-4">
            <div className="flex items-center">
              <div>
                <img
                  width="42"
                  height="42"
                  src="https://i.ibb.co/tCkcP9d/Group-2.png"
                  alt="total-valid-entries"
                />
              </div>
              <div className="px-4 overflow-hidden">
                <p className="text-[#848484] m-0 p-0 md:text-sm text-xs truncate whitespace-nowrap">
                  Total Ignore Entries
                </p>
                <p className="text-xl">{summary?.totalIgnore}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default summary;
